import { useCallback, useEffect } from "react";

export const useOutsideClick = (
  element: HTMLElement | null,
  callback: (e: MouseEvent) => void,
) => {
  const handleClickTest = useCallback(
    (e: MouseEvent) => {
      if (!(e.target instanceof Node)) return;
      if (element?.contains(e.target)) return;

      callback(e);
    },
    [callback, element],
  );

  useEffect(() => {
    document.addEventListener("click", handleClickTest, false);
    return () => {
      document.removeEventListener("click", handleClickTest, false);
    };
  }, [element, handleClickTest]);
};
